import { v4 as uuidv4 } from 'uuid';
import moment from 'moment-timezone';
import { isObject as _isObject, transform, isEqual } from 'lodash';

export const isJson = (str: string): boolean => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const isObject = (object: any): boolean => {
  return _isObject(object);
};

export const generateUUID = (): string => {
  return uuidv4();
};

export const objected = (bean: any) => {
  if (bean) {
    if (isBase64(bean)) {
      const buff: any = Buffer.from(bean, 'base64');
      bean = buff.toString('UTF-8');
    }

    if (isJson(bean)) {
      return JSON.parse(bean);
    }

    if (isObject(bean)) {
      return bean;
    }
  }

  return {};
};

export const objectDiff = (object: any, base: any): object => {
  const baseSort: any = sortObjectByValues(base);
  const objectSort: any = sortObjectByValues(object);

  return transform(objectSort, (result: any, value: any, key: string | number) => {
    if (!isEqual(value, baseSort[key])) {
      result[key] = isObject(value) && isObject(base[key]) ? objectDiff(value, base[key]) : value;
    }
  });
};

export const sortObjectByValues = (object: any) => {
  return object.sort((a: any, b: any) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });
};

export const isBase64 = (str: string): boolean => {
  if (typeof str === 'string') {
    if (str === '' || str.trim() === '') {
      return false;
    }

    try {
      const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
      return base64regex.test(str);
    } catch (err) {
      return false;
    }
  }

  return false;
};

export const getTime = (tz: string, format: string = ''): string => {
  const tzOffset = moment.tz(Date.now(), tz);
  return tzOffset.format(format);
};

export const getTimeByTimestamp = (timestamp: number, tz: string, format: string = ''): string => {
  moment.tz(Date.now(), tz);

  const tzOffset = moment.unix(timestamp);
  return tzOffset.format(format);
};

export const getTZCountry = (countryCode: string): string => {
  return moment.tz.zonesForCountry(countryCode).toString();
};

export const nowTimeStamp = (): number => {
  return Math.floor(+new Date() / 1000);
};

export const getDate = (): Date => {
  return new Date();
};

export const dateFromTS = (timestamp: number): string => {
  const ts_ms = timestamp * 1000;
  const date_ob = new Date(ts_ms);

  const year = date_ob.getFullYear();
  const month = ('0' + (date_ob.getMonth() + 1)).slice(-2);
  const day = ('0' + date_ob.getDate()).slice(-2);
  const hours = ('0' + date_ob.getHours()).slice(-2);
  const minutes = ('0' + date_ob.getMinutes()).slice(-2);
  const seconds = ('0' + date_ob.getSeconds()).slice(-2);

  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
};

export const dateFormat = (): string => {
  const ts_ms = nowTimeStamp() * 1000;
  const date_ob = new Date(ts_ms);

  const year = date_ob.getFullYear();
  const day = ('0' + date_ob.getDate()).slice(-2);
  const month = ('0' + (date_ob.getMonth() + 1)).slice(-2);

  return day + '-' + month + '-' + year;
};

export const replacementValues = (content: any, replacements: any): string => {
  for (const current in replacements) {
    if (replacements.hasOwnProperty(current)) {
      content = content.replace(`{{${current}}}`, replacements[current]);
    }
  }

  return content;
};

export const isEmail = (email: string): boolean => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const isUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

export const capitalize = (s: string): string => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getCorsHeaders = () => {
  return {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Methods': 'OPTIONS, GET, POST, PUT, DELETE'
  };
}; 